var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"employee-badge-counter",on:{"click":function($event){return _vm.$emit('click')}}},_vm._l((_setup.badgeLevels),function(level){return _c('div',{key:level.key,staticClass:"employee-badge-counter__badge",class:`employee-badge-counter__badge--${level.key}`},[_vm._v(" "+_vm._s(level.count)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }